export default function hotjar() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (!window.hj) {
    window.hj = global.window.hj || function ___TMP_HOTJAR___() {
      (window.hj.q = window.hj.q || []).push(arguments);
    };
  }
  window.hj(...args);
}